import { useEffect, useState } from 'react'

import getCurrentSession, { Session } from 'api/auth/getCurrentSession'
import config from 'config'
import { fetchAndStoreVariantSessionKey } from 'hooks/useLosVersion'

const useSession = () => {
    const [session, setSession] = useState<Session>({
        mfaTimeLeft: 0,
        wasRecentlyAuthenticated: false,
    })

    useEffect(() => {
        getCurrentSession().then((currentSession: Session) => {
            setSession(currentSession)

            // In sandbox, pre-populate the variant session key immediately
            // after confirming the user is authenticated.  This covers the
            // Okta SSO path: user authenticates on los.sandbox-eks.octane.co
            // then navigates to the dealer portal (no login form submitted, so
            // LoginPage.tsx never runs).  When the user later selects a LOS
            // variant, the key is already cached and variant API calls
            // authenticate via Authorization: Session <key>.
            //
            // Non-fatal: silently no-ops if GET /api/v3/auth/sessions/key/
            // is not yet available on the main sandbox LOS.
            if (config.ENVIRONMENT === 'sandbox') {
                void fetchAndStoreVariantSessionKey()
            }
        })
    }, [])

    return session
}

export default useSession
